<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vSWXp4/tc-custom/9781446357606.jpg?1726454432804" alt="This image is the cover for the book The Invisible Influence, The Paranormal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Invisible Influence, The Paranormal
      </h1>
      <p class="bookDescription body article font2">
        <p>The Paranormal, the new ebook series from F+W Media International Ltd, resurrecting rare titles, classic publications and out-of-print texts, as well as new ebook titles on the supernatural – other-worldly books for the digital age. The series includes a range of paranormal subjects from angels, fairies and UFOs to near-death experiences, vampires, ghosts and witchcraft. The purpose of this title is to prove that there exists in this mighty world an Invisible Influence that rules our daily lives. It contains a structured conversation between Cannon and a series of mystics, yogis, and other sages, and offers anecdotes of crystal gazing, levitation, hypnotism, distant-touching, and other supposed phenomena.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Cannon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      F+W Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e2ca34f